// Disclaimer.js
import React, { useState, useEffect, useRef } from 'react';
import './Pages/PagesCss/Disclaimer.css';
import { useNavigate } from 'react-router-dom';

// ─── Icons ────────────────────────────────────────────────────────────────────
const Icons = {
  Alert:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 9V13M12 17H12.01M10.3 3.5L2.5 17C1.8 18.2 2.7 19.7 4.2 19.7H19.8C21.3 19.7 22.2 18.2 21.5 17L13.7 3.5C13 2.3 11 2.3 10.3 3.5Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Scale:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 3V21M12 3L6 8M12 3L18 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 13L6 8L9 13C9 14.66 7.66 16 6 16C4.34 16 3 14.66 3 13Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M15 13L18 8L21 13C21 14.66 19.66 16 18 16C16.34 16 15 14.66 15 13Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M4 21H20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  FileX:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M14 2V8H20M10 13L14 17M14 13L10 17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Globe:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 3C12 3 8 7 8 12C8 17 12 21 12 21M12 3C12 3 16 7 16 12C16 17 12 21 12 21M3 12H21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Link:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M10 13C10.4295 13.5741 10.9774 14.0491 11.6066 14.3929C12.2357 14.7367 12.9315 14.9411 13.6467 14.9923C14.3618 15.0435 15.0796 14.9403 15.7513 14.6897C16.4231 14.4392 17.0331 14.047 17.54 13.54L20.54 10.54C21.4508 9.59699 21.9548 8.33397 21.9434 7.02299C21.932 5.71201 21.4061 4.45794 20.4791 3.53087C19.5521 2.60381 18.298 2.07799 16.987 2.0666C15.676 2.0552 14.413 2.55918 13.47 3.46997L11.75 5.17997" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M14 11C13.5705 10.4259 13.0226 9.95088 12.3934 9.60707C11.7642 9.26326 11.0684 9.05885 10.3533 9.00763C9.63816 8.95641 8.92037 9.05963 8.24861 9.3102C7.57685 9.56076 6.96684 9.9529 6.45996 10.46L3.45996 13.46C2.54917 14.403 2.04519 15.666 2.0566 16.977C2.06801 18.288 2.59383 19.5421 3.52089 20.4691C4.44796 21.3962 5.70203 21.922 7.01301 21.9334C8.32399 21.9448 9.58701 21.4408 10.53 20.53L12.24 18.82" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Shield:   (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 3L4 7V12C4 16.42 7.58 21 12 21C16.42 21 20 16.42 20 12V7L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Tool:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3-3a6 6 0 01-7.4 7.4l-5.2 5.2a2 2 0 01-2.8-2.8l5.2-5.2a6 6 0 017.4-7.4l-3 3z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Clock:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 7V12L15 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Mail:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.8"/><path d="M2 8L12 14L22 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Update:   (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M4 12C4 7.58 7.58 4 12 4C14.67 4 17.04 5.27 18.54 7.25" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M20 12C20 16.42 16.42 20 12 20C9.33 20 6.96 18.73 5.46 16.75" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M16 7L18.54 7.25L20 5M8 17L5.46 16.75L4 19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  ChevronRight: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M9 5L16 12L9 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  ArrowUp:  (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 19V5M5 12L12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Info:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 8V8.01M12 11V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>,
};

// ─── Sections data ────────────────────────────────────────────────────────────
const SECTIONS = [
  {
    id: 'general',
    icon: Icons.Alert,
    title: '1. General Disclaimer',
    color: '#F59E0B',
    content: [
      {
        subtitle: 'Use at your own risk',
        body: `The information, tools, and services provided on QuickPDFs.net (operated by D-Tech Studios) are provided on an "as is" and "as available" basis, without any warranties of any kind, either express or implied.

D-Tech Studios expressly disclaims all warranties, including but not limited to implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not warrant that the service will be uninterrupted, error-free, completely secure, or free of viruses or other harmful components.

Your use of QuickPDFs and any reliance on the tools, outputs, or content provided is solely at your own risk.`,
      },
      {
        subtitle: 'No professional advice',
        body: `QuickPDFs is a file processing utility. Nothing on this website constitutes legal, financial, medical, or any other form of professional advice. The tools process your documents they do not review, analyse, or advise on the contents of those documents.

If your documents contain legally sensitive, financially important, or medically relevant information, you should consult a qualified professional before relying on any processed output.`,
      },
    ],
  },
  {
    id: 'accuracy',
    icon: Icons.Tool,
    title: '2. Accuracy of Outputs',
    color: '#3B82F6',
    content: [
      {
        subtitle: 'Conversion and processing accuracy',
        body: `While we strive to provide high-quality PDF processing tools, we cannot guarantee that every conversion, compression, merge, split, or other operation will produce a perfect result in every case.

Output quality depends on a number of factors outside our control, including:

• The quality and structure of the original file
• Whether the original PDF was created from a digital source or scanned image
• The complexity of fonts, layouts, tables, or embedded media
• Whether the PDF contains non-standard or proprietary encoding

You should always review processed outputs before using them in any professional, legal, or critical context.`,
      },
      {
        subtitle: 'OCR accuracy',
        body: `Our OCR (Optical Character Recognition) tool converts scanned images and non-searchable PDFs into searchable text. OCR accuracy depends heavily on the quality of the original scan, lighting conditions, font type, and language. We do not guarantee character-perfect OCR output.

Always proofread OCR results, especially before using them in legal, medical, financial, or academic documents. D-Tech Studios accepts no liability for errors introduced during OCR processing.`,
      },
      {
        subtitle: 'File integrity',
        body: `We take care to preserve the integrity of your files during processing. However, edge cases exist in PDF standards particularly with older, password-protected, or digitally-signed documents where processing may alter or strip certain features.

We strongly recommend keeping a backup of your original files before processing. D-Tech Studios is not responsible for any loss of data, formatting, digital signatures, or document features that may occur during processing.`,
      },
    ],
  },
  {
    id: 'liability',
    icon: Icons.Scale,
    title: '3. Limitation of Liability',
    color: '#EF4444',
    content: [
      {
        subtitle: 'No liability for direct or indirect losses',
        body: `To the maximum extent permitted by applicable law, D-Tech Studios, its directors, employees, partners, agents, suppliers, and affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to:

• Loss of profits, revenue, or business
• Loss or corruption of data or files
• Loss of goodwill
• Service interruptions
• Any other losses arising from your use of, or inability to use, QuickPDFs

This limitation applies whether the alleged liability is based on contract, tort, negligence, strict liability, or any other basis, even if D-Tech Studios has been advised of the possibility of such damages.`,
      },
      {
        subtitle: 'Aggregate liability cap',
        body: `In jurisdictions where limitations of liability are permitted, our total aggregate liability to you for any claims arising from your use of QuickPDFs shall not exceed the greater of:

• The total amount you paid to D-Tech Studios in the 12 months preceding the claim, or
• USD $20 for free plan users

Some jurisdictions do not allow the exclusion or limitation of liability for certain types of damages. In such jurisdictions, our liability is limited to the fullest extent permitted by law.`,
      },
      {
        subtitle: 'Force majeure',
        body: `D-Tech Studios shall not be liable for any failure or delay in performance of its obligations under these terms where such failure or delay results from any cause beyond our reasonable control, including but not limited to natural disasters, acts of government, internet outages, third-party service failures, cyberattacks, or power failures.`,
      },
    ],
  },
  {
    id: 'thirdparty',
    icon: Icons.Link,
    title: '4. Third-Party Services & Links',
    color: '#8B5CF6',
    content: [
      {
        subtitle: 'External links',
        body: `QuickPDFs may contain links to third-party websites, services, or resources. These links are provided for your convenience only. D-Tech Studios has no control over the content, privacy practices, or availability of those external sites and accepts no responsibility or liability for them.

The inclusion of a link to any third-party website does not imply endorsement, recommendation, or approval by D-Tech Studios of that website or its contents.`,
      },
      {
        subtitle: 'Third-party infrastructure',
        body: `QuickPDFs is built on top of third-party infrastructure and services including cloud hosting providers, CDN networks, payment processors, and analytics tools. While we select these providers carefully and hold them to contractual standards, we are not responsible for any failures, outages, or security incidents originating from those providers.

If a third-party service failure causes an interruption to QuickPDFs, we will work to resolve it as quickly as possible but cannot be held liable for any losses during that period.`,
      },
      {
        subtitle: 'Open source components',
        body: `QuickPDFs uses open-source libraries and software components. These components are used in accordance with their respective licenses. D-Tech Studios makes no warranty regarding the fitness, accuracy, or security of open-source components used within the service. You accept that such components may introduce limitations or issues beyond our control.`,
      },
    ],
  },
  {
    id: 'filecontent',
    icon: Icons.FileX,
    title: '5. File Content Disclaimer',
    color: '#10B981',
    content: [
      {
        subtitle: 'Your responsibility for file content',
        body: `You are solely responsible for the content of any files you upload to QuickPDFs. By using the service, you represent and warrant that:

• You own or have the legal right to process the files you upload
• Your files do not infringe any third-party intellectual property rights
• Your files do not contain illegal content of any kind
• You will not use QuickPDFs to process files in violation of any applicable law

D-Tech Studios does not review the contents of uploaded files and accepts no liability for any legal claims, damages, or consequences arising from the content of files you process through our service.`,
      },
      {
        subtitle: 'Copyright and intellectual property',
        body: `Processing a file through QuickPDFs does not grant you any new rights over that file's content. If a document is protected by copyright, password, or digital rights management (DRM), using our tools to bypass those protections may be illegal in your jurisdiction.

We do not endorse, facilitate, or accept any liability for the circumvention of copyright protections or DRM systems. You use such functionality entirely at your own legal risk.`,
      },
      {
        subtitle: 'Confidential and sensitive documents',
        body: `While we take strong technical measures to protect your files (TLS encryption in transit, AES-256 encryption at rest, automatic deletion within 1 hour), no internet-based service can be guaranteed 100% secure.

If you are processing highly confidential, classified, attorney-client privileged, or similarly sensitive documents, you should carefully consider whether a cloud-based processing tool is appropriate for your use case. D-Tech Studios recommends that users with such requirements consult their organisation's security policies before using any online file processing service.`,
      },
    ],
  },
  {
    id: 'availability',
    icon: Icons.Clock,
    title: '6. Service Availability',
    color: '#3B82F6',
    content: [
      {
        subtitle: 'No uptime guarantee for free plan',
        body: `While we aim for high availability and strive to maintain 99.9% uptime, QuickPDFs is provided without any guarantee of uninterrupted service, particularly for free plan users. We may perform scheduled or emergency maintenance at any time.

Paid subscribers (Pro and Business) benefit from priority processing queues and our best-effort SLA commitments, but these do not constitute a legally binding uptime guarantee unless separately agreed in writing.`,
      },
      {
        subtitle: 'Right to modify or discontinue',
        body: `D-Tech Studios reserves the right to modify, suspend, or discontinue any part of the QuickPDFs service at any time, with or without notice. We will make reasonable efforts to provide advance notice of significant changes to paid subscribers.

We shall not be liable to you or any third party for any modification, suspension, or discontinuation of the service, including any loss of data, features, or access to your account.`,
      },
    ],
  },
  {
    id: 'jurisdiction',
    icon: Icons.Globe,
    title: '7. Governing Law & Jurisdiction',
    color: '#F59E0B',
    content: [
      {
        subtitle: 'Applicable law',
        body: `This Disclaimer, along with our Terms of Service and Privacy Policy, shall be governed by and construed in accordance with the laws applicable to D-Tech Studios as a registered entity, without regard to its conflict of law provisions.

Users accessing QuickPDFs from other jurisdictions are responsible for compliance with local laws and regulations to the extent those laws apply to them.`,
      },
      {
        subtitle: 'Dispute resolution',
        body: `In the event of any dispute arising from your use of QuickPDFs or these terms, we encourage you to contact us first at legal@quickpdfs.net. We will make a good-faith effort to resolve disputes informally within 30 days.

If informal resolution is not possible, disputes shall be submitted to binding arbitration or the courts of competent jurisdiction as applicable under the governing law above, except where prohibited by your local consumer protection laws.`,
      },
    ],
  },
  {
    id: 'changes',
    icon: Icons.Update,
    title: '8. Changes to This Disclaimer',
    color: '#8B5CF6',
    content: [
      {
        subtitle: 'Right to update',
        body: `D-Tech Studios reserves the right to update, modify, or replace this Disclaimer at any time. When we make material changes, we will update the "Last updated" date at the top of this page.

For registered account holders, we will provide at least 14 days' notice of material changes via email before they take effect. Your continued use of QuickPDFs after changes become effective constitutes your acceptance of the revised Disclaimer.

We recommend reviewing this page periodically. The current version of this Disclaimer is always available at quickpdfs.net/disclaimer.`,
      },
    ],
  },
  {
    id: 'contact',
    icon: Icons.Mail,
    title: '9. Contact',
    color: '#10B981',
    content: [
      {
        subtitle: 'Questions and legal notices',
        body: `If you have any questions about this Disclaimer, wish to report a concern, or need to serve a legal notice on D-Tech Studios, please contact us at:

General queries: legal@quickpdfs.net
Support: support@quickpdfs.net
Privacy matters: privacy@quickpdfs.net

Company: D-Tech Studios
Product: QuickPDFs.net

We aim to respond to all legal and formal queries within 5 business days.`,
      },
    ],
  },
];

// ─── Component ────────────────────────────────────────────────────────────────
export default function Disclaimer() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('general');
  const [showBackToTop, setShowBackToTop] = useState(false);
  const sectionRefs = useRef({});

  useEffect(() => {
    const handler = () => setShowBackToTop(window.scrollY > 400);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) setActiveSection(entry.target.id);
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    Object.values(sectionRefs.current).forEach(ref => { if (ref) observer.observe(ref); });
    return () => observer.disconnect();
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const LAST_UPDATED = 'March 18, 2026';

  return (
    <div className="ds-page">

      {/* ── Hero ──────────────────────────────────────────── */}
      <section className="ds-hero">
        <div className="ds-hero-bg" aria-hidden="true" />
        <div className="ds-container">

          <div className="ds-hero-badge">
            <span className="ds-badge-dot" />
            D-Tech Studios · QuickPDFs.net
          </div>

          <h1 className="ds-hero-title">Disclaimer</h1>
          <p className="ds-hero-sub">
            Please read this disclaimer carefully before using QuickPDFs.net.
            By accessing or using the service, you acknowledge that you have read,
            understood, and agree to be bound by these terms.
          </p>

          <div className="ds-hero-meta">
            <span className="ds-meta-item">
              <Icons.Update /> Last updated: <strong>{LAST_UPDATED}</strong>
            </span>
            <span className="ds-meta-sep">·</span>
            <span className="ds-meta-item">
              Operated by <strong>D-Tech Studios</strong>
            </span>
          </div>

          {/* Key notice banner */}
          <div className="ds-notice-banner">
            <span className="ds-notice-icon"><Icons.Alert /></span>
            <div className="ds-notice-text">
              <strong>Important:</strong> QuickPDFs is provided "as is" without warranties of any kind.
              We are not liable for any loss of data, file corruption, or damages arising from use of this service.
              Always keep backups of important files before processing.
            </div>
          </div>
        </div>
      </section>

      {/* ── Body ──────────────────────────────────────────── */}
      <div className="ds-body">
        <div className="ds-container ds-body-inner">

          {/* TOC sidebar */}
          <aside className="ds-toc">
            <p className="ds-toc-label">Contents</p>
            <nav className="ds-toc-nav">
              {SECTIONS.map(s => (
                <button
                  key={s.id}
                  className={`ds-toc-item${activeSection === s.id ? ' active' : ''}`}
                  style={{ '--tc': s.color }}
                  onClick={() => scrollTo(s.id)}
                >
                  <span className="ds-toc-dot" style={{ background: s.color }} />
                  <span className="ds-toc-text">{s.title}</span>
                  <Icons.ChevronRight className="ds-toc-arrow" />
                </button>
              ))}
            </nav>
            <div className="ds-toc-footer">
              <button className="ds-toc-btn" onClick={() => navigate('/privacy-policy')}>
                <Icons.Shield /> Privacy Policy
              </button>
              <button className="ds-toc-btn" onClick={() => navigate('/Contact')}>
                <Icons.Mail /> Contact us
              </button>
            </div>
          </aside>

          {/* Content */}
          <main className="ds-content">
            {SECTIONS.map(section => (
              <section
                key={section.id}
                id={section.id}
                ref={el => (sectionRefs.current[section.id] = el)}
                className="ds-section"
              >
                <div className="ds-section-head">
                  <span className="ds-section-icon" style={{ background: `${section.color}14`, color: section.color }}>
                    <section.icon />
                  </span>
                  <h2 className="ds-section-title">{section.title}</h2>
                </div>

                {section.content.map((block, i) => (
                  <div key={i} className="ds-block">
                    <h3 className="ds-block-title">{block.subtitle}</h3>
                    <div className="ds-block-body">
                      {block.body.split('\n\n').map((para, j) => (
                        <p key={j} className={para.trim().startsWith('•') || para.includes('\n•') ? 'ds-para ds-para--list' : 'ds-para'}>
                          {para.split('\n').map((line, k, arr) => (
                            <span key={k}>
                              {line}
                              {k < arr.length - 1 && <br />}
                            </span>
                          ))}
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
              </section>
            ))}

            {/* Footer note */}
            <div className="ds-footer-note">
              <div className="ds-footer-note-left">
                <Icons.Info className="ds-footer-icon" />
                <div>
                  <p className="ds-footer-title">This disclaimer is part of our legal framework</p>
                  <p className="ds-footer-body">
                    Read alongside our{' '}
                    <button className="ds-inline-link" onClick={() => navigate('/PrivacyPolicy')}>Privacy Policy</button>
                    {' '}and{' '}
                    <button className="ds-inline-link" onClick={() => navigate('/TermsOfService')}>Terms of Service</button>
                    {' '}for the full picture. Questions?{' '}
                    <button className="ds-inline-link" onClick={() => navigate('/Contact')}>Contact us</button>.
                  </p>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* Back to top */}
      {showBackToTop && (
        <button
          className="ds-back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Back to top"
        >
          <Icons.ArrowUp />
        </button>
      )}
    </div>
  );
}